import { Overlay } from 'ol';

/** @type {string} */
const ANIMATION_CSS_CLASS = 'anim';

const ANIMATION_DURATION_CSS_VARIABLE = '--longpress-animation-duration';

const DEFAULT_ANIMATION_DURATION = 0.7;

/**
 * @typedef {Object} LongPressAnimOptions
 * @property {number} duration The long press animation duration in second. Default is 0.7.
 */

export default class LongPressAnim extends Overlay {
  /**
     * @constructor
     * @param {LongPressAnimOptions} options The animation options.
     */
  constructor(options = {}) {
    const elt = document.createElement('div');
    elt.className = 'long-press';
    elt.setAttribute('data-anim', 'base wrapper');

    const firstChild = document.createElement('div')
    firstChild.className = 'circle';
    firstChild.setAttribute('data-anim', 'base left');
    elt.appendChild(firstChild);

    const secondChild = document.createElement('div')
    secondChild.className = 'circle';
    secondChild.setAttribute('data-anim', 'base right');
    elt.appendChild(secondChild);

    const thirdChild = document.createElement('div')
    thirdChild.className = 'disk';
    elt.appendChild(thirdChild);

    super({
      stopEvent: false,
      positioning: 'bottom-center',
      element: elt
    });

    /**
         * The animation duration
         * @private
         * @type {number}
         */
    this.duration_ = options.duration || DEFAULT_ANIMATION_DURATION;
  }

  /**
     * Start the animation.
     * @param {import("ol/coordinate").Coordinate} coordinate The coordinate to set the animation.
     */
  start(coordinate) {
    document.documentElement.style.setProperty(ANIMATION_DURATION_CSS_VARIABLE, `${this.duration_}s`)
    this.getElement().classList.add(ANIMATION_CSS_CLASS);
    this.setPosition(coordinate);
  }

  /**
     * Stop the animation.
     */
  stop() {
    this.getElement().classList.remove(ANIMATION_CSS_CLASS);
  }
}
